import React, { Fragment } from 'react'
import { connect } from 'react-redux'
import CSSModules from 'react-css-modules'
import { Link } from 'react-router-dom'

import styles from './styles.scss'

import { 
    projectSelectedSelector
} from 'containers/Form/Project/selectors'


const mapStateToProps = (state) => {
    return {
      projectSelected: projectSelectedSelector(state)
    }
  }

const ConfirmPage = ({ projectSelected : { value, projectName, sku, brand, partnerSite }}) =>
{
  const mapping = [
    {
      label: 'Project Name',
      value: projectName
    },
    {
      label: 'SKU',
      value: sku
    },
    {
      label: 'Brand',
      value: brand
    },
    {
      label: 'Partner Site',
      value: partnerSite
    },
  ]
  return (
    <Fragment>
      <p>Are sure you want to import from Project&nbsp;
        <Link to={`/project/${value}/view`} target="_blank" rel="noopener noreferrer">
          #{value}?
        </Link>
      </p>
      <div styleName="selectedProjectDetail">
        {mapping.map(({label, value}) => (<p key={label}>{label}: <b>{value}</b></p>))}
      </div>
      <p><b>All fields will be replaced by the new project.</b></p>
    </Fragment>
  )
}

const withConnect = connect(mapStateToProps, null)
const styledComponent = CSSModules(ConfirmPage, styles)
export default withConnect(styledComponent)
